import { SenderAndRecipientsBlockV2 } from "./SenderAndRecipients";
import { SlackMessageEditor } from "./SlackMessageEditor";

export const SlackMessageBlock = {
  SenderAndRecipients: SenderAndRecipientsBlockV2,
  MessageEditor: SlackMessageEditor
};
